import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBanknoteClockSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={50} height={50} fill="none" {...props}>
      <rect
        width={46}
        height={46}
        x={2}
        y={2}
        stroke="url(#banknote-clock-small_svg__a)"
        strokeWidth={4}
        rx={23}
      />
      <g clipPath="url(#banknote-clock-small_svg__b)">
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.781}
          d="M27.682 23.633a2.318 2.318 0 1 1-4.637 0 2.318 2.318 0 0 1 4.636 0"
        />
        <path
          fill="#0C1C43"
          d="M30.457 17.833a2.45 2.45 0 0 1 2.452 2.451v1.982a.391.391 0 0 1-.781 0v-1.982a1.67 1.67 0 0 0-1.671-1.67H19.639a1.67 1.67 0 0 0-1.67 1.67v6.697c0 .923.747 1.67 1.67 1.67h6.142a.39.39 0 0 1 0 .782H19.64a2.45 2.45 0 0 1-2.451-2.452v-6.697a2.45 2.45 0 0 1 2.45-2.451z"
        />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.781}
          d="M31.966 32.032a3.581 3.581 0 1 0 0-7.162 3.581 3.581 0 0 0 0 7.162"
        />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.781}
          d="M31.91 27.03v1.82l1.023.909"
        />
      </g>
      <defs>
        <linearGradient
          id="banknote-clock-small_svg__a"
          x1={25}
          x2={25}
          y1={0}
          y2={50}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="banknote-clock-small_svg__b">
          <path fill="#fff" d="M14.063 14.063h21.874v21.874H14.064z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBanknoteClockSmall);
export default ForwardRef;
